import { render, staticRenderFns } from "./IosDeviceDetail.vue?vue&type=template&id=0cea8c7a&scoped=true&"
import script from "./IosDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./IosDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./IosDeviceDetail.vue?vue&type=style&index=0&id=0cea8c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea8c7a",
  null
  
)

export default component.exports